/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

// Feature flag key for home page tile redirect to new search pages (mobile web only)
export const FEATURE_FLAG_HOTEL_HOME_TILE_REDIRECT_ENABLED =
  'hotel_home_tile_redirect_new_search_enabled' as const;

export const FEATURE_FLAG__SNAP_HOME_TILE_REDIRECT_ENABLED =
  'snap_home_tile_redirect_new_search_enabled' as const;

export const FEATURE_FLAG_HOME_ENABLE_ADS_RENDER =
  'home_enable_ads_render' as const;

export const FEATURE_FLAG_MOVEMENTS_AGE_RESTRICTION_ENABLED =
  'movements_age_restriction_enabled' as const;

export const MINIMUM_ALLOWED_AGE_YEARS = 'minimum_allowed_age_years' as const;

export const FEATURE_FLAG_ENABLE_MOVEMENTS_SOCIAL_GRID =
  'enable_movements_social_grid' as const;

export const FEATURE_FLAG_HOME_ENABLE_RN_SEARCH_VISIBLE =
  'enable_rn_search_visible' as const;
